var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationLeads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "inherit",
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.572 11.495h-.5v1h.5v-1Zm6.857 1h.5v-1h-.5v1Zm-6.857 1.79h-.5v.5h.5v-.5Zm6.857 0v.5h.5v-.5h-.5Zm-6.857-4.57v-.5h-.5v.5h.5Zm6.857 0h.5v-.5h-.5v.5Zm3.428-2.286h.5V7.22l-.146-.146-.354.354ZM15.43 4l.353-.354-.146-.146h-.207V4Zm-6.857 8.495h6.857v-1H8.572v1Zm0 2.29h6.857v-1H8.572v1Zm0-4.57h6.857v-1H8.572v1Zm9.143 9.285H6.285v1h11.43v-1Zm-12.072-.643V5.143h-1v13.714h1ZM18.357 7.43v11.428h1V7.43h-1ZM6.286 4.5h9.143v-1H6.286v1Zm8.79-.146 3.428 3.428.707-.707-3.429-3.429-.707.708ZM6.285 19.5a.643.643 0 0 1-.643-.643h-1c0 .908.736 1.643 1.643 1.643v-1Zm11.429 1c.907 0 1.642-.735 1.642-1.643h-1a.643.643 0 0 1-.642.643v1ZM5.643 5.143c0-.355.288-.643.643-.643v-1c-.907 0-1.643.736-1.643 1.643h1Zm2.429 4.571v4.572h1V9.714h-1Zm3.428 0v4.572h1V9.714h-1Zm3.429 0v4.572h1V9.714h-1ZM8 7.93h3.429v-1H8v1Zm4.572 9.142H16v-1h-3.428v1Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationLeads);
export default __webpack_public_path__ + "static/media/navigation-leads.a7e4f68fe3594bacd0819597005c1d03.svg";
export { ForwardRef as ReactComponent };